const ACTIVE_STATUSES = ["active", "trialing", "trial", "paid", "approved"];

export const normalizePlan = (plan = {}) => {
  const planType =
    plan?.planType || plan?.plan_type || plan?.type || plan?.category || "";
  const audience = String(
    plan?.audience || plan?.planAudience || plan?.plan_audience || ""
  ).toLowerCase();
  const maxVehicles =
    plan?.maxVehicles ?? plan?.limit ?? plan?.maxVehicles ?? 0;
  const parsedPrice = Number(
    plan?.price ?? plan?.plan_price ?? plan?.amount ?? plan?.planAmount ?? 0
  );

  return {
    id:
      plan?.id ||
      plan?._id ||
      plan?.uuid ||
      plan?.plan_id ||
      plan?.planId ||
      plan?.name,
    name: plan?.name || plan?.plan_name || "Unnamed Plan",
    category: plan?.category || plan?.plan_category || "",
    description: plan?.description || plan?.plan_description || "",
    audience: audience || "fleet",
    type: planType?.toLowerCase() || "custom",
    maxVehicles: Number.isFinite(maxVehicles) ? maxVehicles : 0,
    maxDrivers: Number.isFinite(plan?.maxDrivers) ? plan?.maxDrivers : 0,
    maxFleetAllowed: Number.isFinite(plan?.maxFleetAllowed)
      ? plan?.maxFleetAllowed
      : 0,
    price: Number.isFinite(parsedPrice) ? parsedPrice : 0,
    raw: plan,
  };
};

const isStatusActive = (status) =>
  typeof status === "string" && ACTIVE_STATUSES.includes(status.toLowerCase());

export const hasActiveSubscription = (user, subscription_status) => {
  if (!user) return false;

  const roleName = user?.role?.name || user?.role;
  if (roleName === "super_admin") {
    return true;
  }

  // Check subscription_status from parameter or user object
  const subscriptionStatus = subscription_status || user?.subscription_status;

  if (subscriptionStatus) {
    // Check if subscription has a status field and it's active
    if (
      typeof subscriptionStatus.status === "string" &&
      isStatusActive(subscriptionStatus.status)
    ) {
      return true;
    }

    // Check if subscription has an expiration date in the future
    if (subscriptionStatus.expiration_date) {
      const expirationDate = new Date(subscriptionStatus.expiration_date);
      if (expirationDate > new Date()) {
        return true;
      }
    }

    // Check if subscription has a plan_id
    if (subscriptionStatus.plan_id || subscriptionStatus.plan?.id) {
      return true;
    }
  }

  // Fallback to company-based checks
  const company =
    user?.company ||
    user?.company_details ||
    user?.companyDetail ||
    user?.organization;

  if (!company) return false;

  if (typeof company?.is_subscribed !== "undefined") {
    return Boolean(company.is_subscribed);
  }

  const status = company?.subscription_status || company?.subscriptionStatus;

  if (isStatusActive(status)) {
    return true;
  }

  if (isStatusActive(company?.plan?.status)) {
    return true;
  }

  if (company?.plan_id || company?.planId) {
    return true;
  }

  if (company?.plan && Object.keys(company.plan).length > 0) {
    return true;
  }

  if (user?.plan_id || user?.planId) {
    return true;
  }

  return false;
};
